
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/conversations",
      function () {
        return require("private-next-pages/conversations/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/conversations"])
      });
    }
  